// 血糖
<template>

  <div>
    <div class="item-hd">
      <div>
        {{ $t('viewBase.a90') }}：
        <div class="tag" @click="showStartDate=true">
          {{ first ? dateFormat(start, 'YYYY/MM/DD') : $t('viewBase.a50') }}
        </div>
        -
        <div class="tag" @click="showEndDate=true">
          {{ first ? dateFormat(end, 'YYYY/MM/DD') : $t('viewBase.a51') }}
        </div>
      </div>
      <van-icon name="plus" class="addData" @click="handlePopup" />
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <div v-for="(item,index) in list" :key="index" class="data">
        <div class="hd">
          {{ dateFormat(item.testTime, 'MM-DD hh:mm') }}
        </div>
        <div class="bd">
          <div>
            <span v-if="item.state==='string'||item.state===''||item.state==='0'||item.state===null">
              {{ item.bs }}
            </span>
            <span v-else-if="!item.normal">
              <span v-if="strChangeArr(item.state2)[0]!=='正常'" class="abnormal">
                {{ item.bs }}
              </span>
              <span v-else>
                {{ item.bs }}
              </span>
            </span>
            <span v-else>{{ item.bs }}</span>&nbsp;mmol/L
            <i v-if="strChangeArr(item.state2)[0]==='偏高'" class="iconfont icon-iconset0414 abnormal" />
            <i v-if="strChangeArr(item.state2)[0]==='偏低'" class="iconfont icon-xiajiantou abnormal" />
            <span v-if="strChangeArr(item.state2)[0]==='正常'" class="abnormal-mr" />
          </div>
        </div>
      </div>
    </van-list>
    <!-- start -->
    <van-datetime-picker
      v-show="showStartDate"
      v-model="start"
      type="date"
      :max-date="end"
      cancel-button-text=" "
      @confirm="handleDateConfirm('start')"
    />
    <!-- end -->
    <van-datetime-picker
      v-show="showEndDate"
      v-model="end"
      type="date"
      :max-date="maxDate"
      cancel-button-text=" "
      @confirm="handleDateConfirm('end')"
    />

    <van-popup v-model="showPopup" position="bottom" @close="showMeasureDate=false">
      <div class="popup-title">{{ $t('viewBase.a92') }}</div>

      <van-cell-group>
        <van-cell title="测量时时段" class="bstime">
          <van-button size="small" :class="{ active: dataForm.bsTime == 'FPG'}" round plain hairline @click="dataForm.bsTime='FPG'">餐前</van-button>
          <van-button size="small" :class="{ active: dataForm.bsTime == 'TWOHPPG'}" round plain hairline @click="dataForm.bsTime='TWOHPPG'">餐后</van-button>
          <!-- <van-button size="small" :class="{ active: dataForm.bsTime == 'TWOHPPG'}" round plain hairline @click="dataForm.bsTime='TWOHPPG'">随机</van-button> -->
        </van-cell>
        <van-field
          v-model="dataForm.bs"
          clearable
          label="血糖"
          input-align="right"
          placeholder="请输入血糖"
        />
        <van-cell title="测量时间" :value="dataForm.measureDate ? dateFormat(dataForm.measureDate, 'YYYY-MM-DD hh:mm') : $t('viewBase.a72')" is-link @click="showMeasureDate=true" />
        <van-button type="info" class="btn" @click="submit">提交</van-button>
      </van-cell-group>
    </van-popup>

    <van-datetime-picker
      v-show="showMeasureDate"
      v-model="dataForm.measureDate"
      type="datetime"
      cancel-button-text=" "
      :max-date="maxDate"
      @confirm="handleMeasureDateConfirm"
    />

  </div>
</template>

<script>
import { getAccountId } from '@/utils/auth'
import { dateFormat, dateISO, strChangeArr } from '@/utils/tool'
import { fetchBs, postBs } from '@/api/health'

export default {
  data() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return {
      first: false,
      showMeasureDate: false,
      datetime: new Date(),
      showPopup: false,
      dateFormat,
      strChangeArr,
      showStartDate: false,
      showEndDate: false,
      start: date,
      end: new Date(),
      showDate: false,
      date: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      tips: '',
      loading: false,
      finished: false,
      list: [],
      listQuery: {
        sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
        eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
        page: 1,
        row: 20
      },
      dataForm: {
        accountId: getAccountId() || 1,
        deviceCode: 'string',
        state: 'string',
        measureDate: new Date(),
        bsTime: 'FPG'
      }
    }
  },
  created() {

  },
  methods: {
    getList(date) {
      if (this.start) {
        this.listQuery.sTime = dateISO(`${dateFormat(this.start, 'YYYY/MM/DD')} 00:00:01`)
      }
      if (this.end) {
        this.listQuery.eTime = dateISO(`${dateFormat(this.end, 'YYYY/MM/DD')} 23:59:59`)
      }
      fetchBs(this.listQuery).then(res => {
        this.loading = false
        const list = res.data.data
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.listQuery.page++
        this.finished = list.length < 20
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
      })
    },

    handleDateConfirm(e) {
      this.first = true
      this.showStartDate = false
      this.showEndDate = false
      this.listQuery.page = 1
      this.getList()
    },

    handleMeasureDateConfirm() {
      this.showMeasureDate = false
      this.datetime = this.currentDate
    },

    handlePopup() {
      this.showPopup = true
    },
    submit() {
      this.dataForm.testTime = dateISO(this.dataForm.measureDate)
      postBs([this.dataForm]).then(res => {
        this.$toast('提交成功')
        this.showPopup = false
        this.showMeasureDate = false
        this.listQuery.page = 1
        this.currentDate = new Date()
        this.getList()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .item-hd {
    background: #fff;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .addData {
      font-size: 18px;
  }
  .tag {
    display: inline-block;
    color: #666;
    padding: 5px 10px;
    background: #f8f8f8;
    border-radius: 1px solid #ececec;
    border-radius: 15px;
  }
  .data {
      display: flex;
      justify-content: space-between;
      background: #fff;
      margin-top: 10px;
      padding: 12px 15px;
      .hd {
          color: #999;
      }
      .bd {
          color: #666;
          text-align: right;
      }
  }
  .van-picker {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    }
    .popup-title {
        text-align: center;
        padding: 10px;
        font-weight: bold;
    }
    .btn {
        width: 92%;
        margin: 30px 4% 20px;
    }
    .bstime {
      .van-cell__title {
        width: 150px;
        flex: none;
      }
      .van-cell__value {
        flex: auto;
      }
      .active {
        background: #F99600;
        color: #fff;
      }
    }
    .bd span{
      width:auto;
      display: inline-block;
    }
    .bd .abnormal-mr{
width:16px;
    }
</style>
